import { ref } from 'vue';
import { v4 as createUUID } from 'uuid';
import { useCommonStore } from '@stores';

//
const NAVER_STATE = '___naverState___';

export const useNaver = () => {
  const commonStore = useCommonStore();
  const clientId = import.meta.env.VITE_APP_OAUTH_NAVER_CLIENT_ID;
  const redirectUri = `${window.location.origin}/auth/callback-naver`;

  const state = ref(commonStore.getSessionStorage(NAVER_STATE));
  if (!state.value) {
    state.value = createUUID();
    commonStore.setStorage('sessionStorage', NAVER_STATE, state.value);
  }

  const requestAuthUrl = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state.value}`;

  return {
    requestAuthUrl,
    state,
    redirectUri,
    NAVER_STATE,
  };
};
